import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AlertMessage from '../../../components/elements/alert-message/AlertMessage.jsx';
import Loading from '../../../components/elements/loading/Loading.jsx';
import FileManager from '../../../components/page-sections/file-manager/FileManager.jsx';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import TitlePanel from '../../../components/sections/title-panel/TitlePanel';
import { useServer } from '../../../contexts/ServerContext';
import { sentenceCase } from '../../../utils/utils.jsx';

const HOME_PATH = '/home/gps';
const BASE_FOLDER_CHAIN = [{ id: 'base_file', name: 'scripts', isDir: true }];

const ServerFileManagerPage = () => {
  const { server, loading } = useServer();
  const { t } = useTranslation();

  if (loading) return <Loading />;

  return server ? (
    <Container>
      <Breadcrumbs serverName={server.name} />
      <TitlePanel title={t('fileManager', { ns: 'titles' })} />
      <FileManager basePath={HOME_PATH} baseFolderChain={BASE_FOLDER_CHAIN} />
    </Container>
  ) : (
    <AlertMessage
      severity="error"
      message={sentenceCase(
        t('loading', {
          ns: 'errors',
          content: t('requestedFileList', { ns: 'instance' }),
        })
      )}
    />
  );
};

export default ServerFileManagerPage;
